<template>
  <div class="requirement-detail-container page-common-detail-container" v-loading="pageloading"
    style="min-height: 500px">
    <div class="detail__wrapper" v-if="requirement">
      <div class="detail__top-info-bar">
        <div class="info-bar__publisher-avatar" @click="toprofile">
          <img :src="requirement.user_avatar" alt="" v-if="!$isMobile" />
          <p class="rname">
            <strong>{{ requirement.name }}</strong>
          </p>
        </div>
        <div class="info-bar__publish-bt" @click="commonPublish" v-if="userInfo && !userInfo.isMerchant">
          发布
        </div>
      </div>
      <!-- 其他数据 -->
      <div class="other-info">
        <div class="info__type">{{ requirement.mold_name }}</div>
        <div class="info__item">
          <i class="icon icon-view"></i>
          <p>{{ requirement.browsenums }}</p>
        </div>
        <div class="info__item">
          <i class="icon icon-collect"></i>
          <p>{{ requirement.collectnums }}</p>
        </div>
        <div class="info__item">
          <p>{{ requirement.ctime | parseTime }}</p>
        </div>
      </div>
      <!-- 需求参数 -->
      <div class="requirement-params-container">
        <div class="params__title">
          <div class="title__text"></div>
          <div class="title__requirement-status"></div>
        </div>
        <div class="params__wrapper" :class="[requirement.status === 2 ? 'finish' : '']">
          <table class="params__main-body">
            <tr>
              <td>需求地点</td>
              <td>{{ requirement.address }}</td>
            </tr>
            <tr>
              <td>需求功能</td>
              <td>{{ requirement.function }}</td>
            </tr>
            <tr>
              <td>需求规模</td>
              <td>{{ requirement.scale }}</td>
            </tr>
            <tr v-if="requirement && requirement.expand">
              <td>居间费</td>
              <td>{{ requirement.expand.rate }}</td>
            </tr>
            <tr>
              <td>需求描述</td>
              <td>{{ requirement.content }}</td>
            </tr>
            <tr v-if="!$isMobile">
              <td>需求图片</td>
              <td>
                <div class="imgs__wrapper"
                  v-if="requirement.picture_ids.length > 0 && requirement.picture_ids[0] != null">
                  <el-image :src="pic.url | parseImage" alt="" v-for="(pic, index) in requirement.picture_ids"
                    :key="index" class="img" fit="cover" lazy
                    :preview-src-list="requirement.picture_ids | parseImage"></el-image>
                </div>
              </td>
            </tr>
            <template v-else>
              <tr>
                <td colspan="2" class="sp4mobile">需求图片</td>
              </tr>
              <tr>
                <td colspan="2" class="sp4mobile-val">
                  <div class="img-box-container">
                    <div class="container-wrapper">
                      <div class="container-mask">
                        <el-image :src="pic.url | parseImage" alt="" v-for="(pic, index) in requirement.picture_ids"
                          :key="index" class="img-box" fit="cover" lazy
                          :preview-src-list="requirement.picture_ids | parseImage"></el-image>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="detail__actions-container requirement-bts-container --followup">
        <div class="hint" style="line-height:1.5;">
          <p>注意：确认跟进需求可以拨打下方电话联系平台获取更多项目信息。</p>
          <p>
            确认跟进本项目即代表接受与材料在线平台约定的项目居间费，居间佣金按合同总额的一定比例收取，本案以上方表格中标注居间费为准。
          </p>
          <p>“合同总额”是指需求方与甲方签订的总体合同，合同费用并非只指材料合同，其包含施工及材料供应的总体费用。</p>
        </div>
        <div class="inner">
          <template v-if="followID > 0 && !pageloading">
            <template v-if="attendStatus != 11">
              <el-button class="actions__item --followup" :loading="cancelLoading"
                @click="($event) => cancelDemand($event, followID, cancelCallback)">
                <p class="item__text">取消跟进需求</p>
              </el-button>
              <el-button class="actions__item --followup" :loading="cancelLoading"
                @click="($event) => suspendDemand($event, demandID, followID, suspendCallback)">中止跟进需求</el-button>
              <el-button class="actions__item --distribute" v-if="this.userInfo && Number(this.userInfo.type) === 1"
                @click="showDistribution">
                <p class="item__text">派发需求</p>
              </el-button>
            </template>
          </template>
          <template v-else>
            <el-button class="actions__item --followup"
              @click="($event) => demandConfirm($event, demandID, confirmDemandCallback)" :loading="confirmLoading">
              <p class="item__text">确认跟进需求</p>
            </el-button>
          </template>
          <div class="actions__item --checkoutphone" @click="checkoutPhone">
            <p class="item__text">查看平台电话</p>
            <i class="item__icon"></i>
          </div>
        </div>
      </div>
      <!-- 扩充信息 -->
      <div class="detail__expand-container" :class="{
        hidden: followID == 0,
      }" v-if="requirement && requirement.expand.content && followID > 0">
        <div class="header">
          <p>隐藏信息</p>
        </div>
        <div class="expand-main-body">
          <div class="inner" v-html="requirement.expand.content"></div>
        </div>
        <div class="modal" v-if="followID == 0">
          <div class="content">
            <i class="el-message-box__status el-icon-warning"></i>
            <p>此处项目地址、甲方业主、设计单位等需求隐藏信息，仅确 认跟进后才可查看。</p>
          </div>
          <el-button class="bt" @click="($event) => demandConfirm($event, demandID, confirmDemandCallback)"
            :loading="confirmLoading">确认跟进需求</el-button>
        </div>
      </div>
      <!-- 评论 -->
      <div class="detail__reply-form requirement-reply-form mobileActionShowSign" v-if="followID > 0">
        <div class="form__title">需求跟进记录</div>
        <template v-if="userInfo && userInfo.isMerchant">
          <el-form :model="maintainForm" class="requirement-reply-form" :rules="rules" ref="maintainForm">
            <el-form-item class="form__textarea" prop="process" v-if="nodes">
              <div class="radio-wrapper">
                <p class="label">请选择跟进阶段：</p>
                <el-checkbox-group class="radio-group-wrapper" v-model="maintainForm.process">
                  <el-checkbox v-for="node in nodes" :key="node.id" :label="node.id">
                    {{ node.title }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item class="form__textarea" prop="content">
              <el-input placeholder="请输入项目跟进情况或遇到的问题" type="textarea" v-model="maintainForm.content"></el-input>
            </el-form-item>
            <div class="form__bts">
              <el-form-item prop="picture_ids">
                <el-upload class="demand-upload" :ref="`upload_maintain`" action="#" :auto-upload="false" :multiple="true"
                  :limit="6" :on-exceed="(files, fileList) => {
                    fileOnExceed(files, fileList, 6);
                  }
                    " :on-change="(file, fileList) => {
    fileOnChange(file, fileList);
  }
    " :on-remove="(file, fileList) => {
    fileOnRemove(file, fileList);
  }
    " :file-list="maintainForm.imgs">
                  <el-button class="form__upload bt__item" size="small" type="primary">上传图片</el-button>
                </el-upload>
              </el-form-item>
              <el-button :loading="loading.maintain" class="form__submit bt__item" @click="onSubmitMaintain()"
                style="background-color: #ffb400; border: 0">提交记录，即可获得积分奖励</el-button>
            </div>
          </el-form>
        </template>
      </div>
      <!-- 评论列表 -->
      <template v-if="followID > 0 && maintainRecord.length > 0">
        <reply-list :lists="maintainRecord" type="maintainrecord"></reply-list>
      </template>
    </div>
    <!-- 照片墙 -->
    <pic-wall :limit="fileLimt" :show="picWallShow" :selectedids="form.picture_ids" @close="onPicWallClose"
      @submit="onPicWallSubmit"></pic-wall>
    <!-- 弹出留言 -->
    <el-dialog title="留言" :visible.sync="replyVisible" :close-on-click-modal="false" :before-close="onReplyDialogClose">
      <div class="detail__reply-form requirement-reply-form dialog-reply-form">
        <el-form :model="form" class="requirement-reply-form" :rules="rules" ref="replyForm">
          <el-form-item class="form__textarea" prop="content">
            <el-input placeholder="在这里你可以说些什么" type="textarea" v-model="form.content"></el-input>
          </el-form-item>
          <div class="form__bts">
            <el-form-item prop="picture_ids">
              <!-- <el-upload
                    ref="replyupload"
                    action="#"
                    :multiple="true"
                    :limit="fileLimt"
                    :auto-upload="false"
                    :file-list="fileList"
                    :on-exceed="fileOnExceed"
                    :on-change="fileOnChange"
                    :on-remove="fileOnRemove"
                    list-type="picture"
                    class="form__upload bt__item"
                    >上传图片</el-upload
                  > -->
              <el-button class="form__upload bt__item" @click="showPicWall">选择图片</el-button>
              <ul class="el-upload-list el-upload-list--picture" v-if="form.picture_urls.length > 0">
                <li class="el-upload-list__item is-ready" v-for="(img, imgindex) in form.picture_urls" :key="imgindex"
                  @click="picDel(img.id)">
                  <img :src="img.url | parseImage" class="el-upload-list__item-thumbnail" alt="" />
                  <a href="javascript:void(0)" class="el-upload-list__item-name" style="margin-right: 0"><i
                      class="el-icon-document"></i>图片-{{ img.id }}</a>
                  <label for="" class="el-upload-list__item-status-label">
                    <i class="el-icon-upload-success el-icon-check"></i>
                  </label>
                  <i class="el-icon-close"></i>
                  <i class="el-icon-close-tip"></i>
                </li>
              </ul>
            </el-form-item>
            <el-button :loading="loading.reply" class="form__submit bt__item" @click="onReply">留言</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <template v-if="$isMobile">
      <action-hint :bts="mobileCheckTel"></action-hint>
    </template>
    <!-- 弹出经销商选出 -->
    <distribute-merchant :demandID="demandID" :show.sync="distributeShow"
      @onClose="distributeShow = false"></distribute-merchant>
  </div>
</template>

<script>
import { followup } from "@/mixins/followup";

import actionHint from "@/pages/common/mobile-action-hint.vue";
import MerchantList from "@/pages/merchant/_list.vue";
import DetailBottomBts from "@/pages/common/detailBottomBts.vue";
import ReplyList from "@/pages/common/replies.vue";
import { handlerDetailReply, commonPublish, checkoutLogin } from "@/assets/utils/handler";
import { mapState } from "vuex";
import PayQrcode from "@/pages/common/payQrcode.vue";
import picWall from "@/pages/common/picWall.vue";

import distributeMerchant from "./_select-merchant.vue";

import { getProcess as getMaintainNodes, getMaintainRecord } from "@/api/requirement";
import { maintainDemand } from "@/api/user";

import { upload } from "@/api/common";

export default {
  name: "followupDetail",
  components: {
    MerchantList,
    DetailBottomBts,
    ReplyList,
    PayQrcode,
    picWall,
    actionHint,
    distributeMerchant,
  },
  mixins: [followup],
  props: ["demandID"],
  data() {
    return {
      errorMessage: {
        content: "请填写跟进情况",
        process: "请选择跟进节点",
        imgs: "请上传图片",
      },
      maintainRecord: [],
      nodes: null,
      maintainForm: {
        content: "",
        process: [],
        imgs: [],
      },
      mobileCheckTel: [
        {
          text: "查看需求方电话",
          bg: "#ffb400",
          color: "#fff",
        },
      ],
      //
      requirement: null,
      form: {
        content: "",
        picture_ids: [],
        picture_urls: [],
      },
      fileList: [],
      fileLimt: 9,
      rules: {
        content: [
          {
            required: true,
            message: "请填写评论",
            trigger: "change",
          },
        ],
        picture_ids: [
          {
            required: true,
            message: "请上传图片",
            trigger: "change",
          },
        ],
      },
      loading: {
        reply: false,
        maintain: false,
      },
      pay: {
        visible: false,
        desc: "",
        price: 0,
      },
      picWallShow: false,
      replyVisible: false,
      lookPhone: {
        status: false,
        error: "未登录",
      },
      maintaining: false,
      //
      distributeShow: false,
      attendStatus: null,
    };
  },
  computed: {
    ...mapState("user", {
      userInfo: (state) => state.info,
    }),
    ...mapState(["followupConfigs", "pageloading"]),
    followID() {
      return this.$route.query.followID || 0;
    },
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
    replyVisible(val) {
      if (val) {
        document.querySelector(".base-bone__wrapper").classList.add("auto");
      } else {
        document.querySelector(".base-bone__wrapper").classList.remove("auto");
      }
    },
  },
  mounted() {
    this.$store.commit("SET_LOGIN_TITLE", "如何查看需求方电话？");
  },
  methods: {
    async init() {
      const that = this;
      that.$store.commit("openLoading");
      // 需求详情
      const requirementDetal = await that.$http.post("html/demand/detail", {
        id: that.demandID,
        expand: 1,
        fid: that.followID > 0 ? that.followID : 0,
      });
      that.requirement = requirementDetal.data;

      if (that.followID > 0) {
        const { data } = await getMaintainNodes();
        that.nodes = Object.keys(data).map((item) => ({
          id: item,
          title: data[item],
        }));

        await that.getMaintainRecords();
      }

      that.$store.commit("closeLoading");
    },
    async getMaintainRecords() {
      const that = this;
      const {
        data: { list: records, attendStatus },
      } = await getMaintainRecord(that.demandID, that.followID);
      that.attendStatus = attendStatus;
      that.maintainRecord = records;
    },
    formatMaintain(data) {
      let record = [];
      if (data) {
        const user = data.store;
        record = data.records.map((record) => {
          const temp = record;
          temp["user"] = user;
          return temp;
        });

        if (data.parent && data.parent.records.length > 0) {
          const parent = data.parent.store;
          const temp = data.parent.records.map((record) => {
            const t = record;
            t["user"] = parent;
            return t;
          });
          record.push(...temp);
        }
      }
      return record;
    },
    isReply() {
      return Number(this.requirement.is_phone) === 1;
    },
    onReply() {
      const that = this;
      that.$refs.replyForm.validate((valid) => {
        if (valid) {
          that.loading.reply = true;
          handlerDetailReply(
            that.requirement.id,
            that.form.content,
            that.$dict.COLLECT_TYPE.requirement,
            that.form.picture_ids
          )
            .then(() => {
              that.$message({
                type: "success",
                message: "发布成功",
              });
              that.requirement.commentList.push({
                avatar: that.userInfo.avatar,
                can_del: "1",
                centent: that.form.content,
                ctime: Math.ceil(new Date().getTime() / 1000),
                fabulous_num: 0,
                id: -1,
                picture_ids: that.form.picture_urls.map((item) => item.url),
                user_id: that.userInfo.id,
                user_name: that.userInfo.nickname,
              });
              // 需求修改
              that.requirement.is_phone = 1;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              that.loading.reply = false;
              that.fileList = [];
              that.form.picture_ids = [];
              that.form.picture_urls = [];
              that.$refs.replyForm.resetFields();
              // 关闭弹窗
              if (that.replyVisible) {
                that.closeReplyForm();
              }
            });
        }
      });
    },
    commonPublish() {
      commonPublish("requirement");
    },
    showPicWall() {
      this.picWallShow = true;
    },
    onPicWallClose() {
      this.picWallShow = false;
      if (this.replyVisible) {
        document.querySelector(".base-bone__wrapper").classList.add("auto");
      }
    },
    onPicWallSubmit(ids, pics) {
      this.picWallShow = false;
      this.form.picture_ids = ids;
      this.form.picture_urls = pics;
    },
    picDel(id) {
      this.form.picture_ids = this.form.picture_ids.filter((item) => Number(item) !== Number(id));
      this.form.picture_urls = this.form.picture_urls.filter(
        (item) => Number(item.id) !== Number(id)
      );
    },
    toprofile() { },
    openReplyForm() {
      this.replyVisible = true;
      setTimeout(() => {
        document.body.classList.add("el-popup-parent--hidden");
      }, 200);
    },
    closeReplyForm() {
      this.replyVisible = false;
      document.body.classList.remove("el-popup-parent--hidden");
    },
    onReplyDialogClose(done) {
      const that = this;
      that
        .$confirm("确认不需要查看电话？")
        .then(() => {
          done();
          that.closeReplyForm();
        })
        .catch(() => {
          console.log("没关");
        });
    },
    //
    async onSubmitMaintain() {
      const that = this;
      const empty = Object.keys(that.maintainForm).find((item) => {
        const val = this.maintainForm[item];
        if (Array.isArray(val)) {
          return val.length === 0;
        } else {
          return val === "";
        }
      });

      if (empty === undefined) {
        try {
          that.loading.maintain = true;
          const files = await upload(that.maintainForm.imgs);
          const imgs = files.map((item) => item.data.self_url);
          const data = { ...that.maintainForm };
          // 上传
          data.imgs = imgs;
          maintainDemand(that.followID, data)
            .then((res) => {
              const {
                success,
                data: { isAddScore },
              } = res;
              if (success) {
                const message =
                  isAddScore && that.followupConfigs
                    ? `提交成功，您已获得${that.followupConfigs.score}积分`
                    : "提交成功，感谢您的维护。";
                that.$message({
                  type: "success",
                  message: message,
                });
                that.maintainForm = {
                  content: "",
                  process: 0,
                  imgs: [],
                };
                that.getMaintainRecords();
                that.$refs.maintainForm.clearValidate();
              }
            })
            .finally(() => {
              that.loading.maintain = false;
            });
        } catch (e) {
          console.log(e);
        }
      } else {
        console.log("请全部填写");
        that.$message({
          type: "error",
          message: that.errorMessage[empty],
        });
      }
    },
    fileOnExceed(files, fileList, limit) {
      Message({
        type: "warning",
        message: `最多选择 ${limit} 个图片，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length
          } 个图片`,
      });
    },
    fileOnChange(files, fileList) {
      this.maintainForm.imgs = [...fileList];
    },
    fileOnRemove(files, fileList) {
      this.maintainForm.imgs = [...fileList];
    },
    getRecords() {
      return;
    },
    checkoutPhone() {
      this.$alert(
        `平台电话为${this.requirement.expand.mobile || this.$officialTel}，方便您进行初步了解项目情况。查看设计需求方电话请点击“确认跟进”后在下方隐藏消息内查看。`,
        "平台电话",
        {
          confirmButtonText: "确定",
        }
      );
    },
    confirmDemandCallback(data) {
      this.$router.replace({
        path: `/my/maintain/${this.demandID}?followID=${data.id}`,
      });
    },
    cancelCallback() {
      this.$router.replace({
        path: `/my/maintain/${this.demandID}`,
      });
    },
    suspendCallback() {
      // this.$router.replace({
      //   path: `/my/maintain/${this.demandID}?followID=${this.followID}`,
      // });
      this.$router.go(0);
    },
    showDistribution() {
      console.log("show distribution merchant");
      this.distributeShow = true;
    },
  },
};
</script>

<style lang="scss">
.detail__actions-container {
  position: relative;

  .actions__item {

    &.--followup,
    &.--distribute {
      background-color: #232323;
      color: #fff;
      padding: 0;
    }

    &.--distribute {}
  }
}
</style>
